import "./style.css";
import gsap from "gsap";

export default class Hero {
  static selector = ".s-member-subscription";

  constructor(block) {
    this.block = block;
    this.$bar = block.querySelector("#bar-line");
  }

  onReady() {
    const perc = this.getPercentage() * 100;
    if (perc >= 75) this.$bar.classList.add("red");
    gsap.set(this.$bar, { width: `${perc}%` });
  }

  getPercentage() {
    const startDate = new Date(this.block.getAttribute("data-start"));
    const endDate = new Date(this.block.getAttribute("data-end"));
    const today = new Date();

    if (today <= startDate) {
      return 0;
    } else if (today >= endDate) {
      return 1;
    } else {
      const totalDifference = this.getDaysDifference(endDate, startDate);
      const todayDifference = this.getDaysDifference(endDate, today);
      return 1 - todayDifference / totalDifference;
    }
  }

  getDaysDifference(endDate, startDate) {
    const diffTime = Math.abs(endDate - startDate);
    const diffDate = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return diffDate;
  }

  onScroll({ y }) {}
}
